import { mergeProps } from '@zag-js/solid';
import { createSplitProps } from '../../utils/create-split-props';
import { RenderStrategyProvider, splitRenderStrategyProps, } from '../../utils/render-strategy';
import { ark } from '../factory';
import { useTabs } from './use-tabs';
import { TabsProvider } from './use-tabs-context';
export const TabsRoot = (props) => {
    const [renderStrategyProps, tabsProps] = splitRenderStrategyProps(props);
    const [useTabsProps, restProps] = createSplitProps()(tabsProps, [
        'activationMode',
        'composite',
        'defaultValue',
        'id',
        'ids',
        'loopFocus',
        'onFocusChange',
        'onValueChange',
        'orientation',
        'translations',
        'value',
    ]);
    const api = useTabs(useTabsProps);
    const mergedProps = mergeProps(() => api().getRootProps(), restProps);
    return (<TabsProvider value={api}>
      <RenderStrategyProvider value={renderStrategyProps}>
        <ark.div {...mergedProps}/>
      </RenderStrategyProvider>
    </TabsProvider>);
};
